import { computed } from 'vue';
import { useStore } from 'vuex';
import CapDonVi from '@/core/enums/CapDonVi.enums';

const useCapDonVi = () => {
  const store = useStore();

  const capDonVi = computed<number>(() => store.getters.capDonVi ?? CapDonVi.DON_VI);
  const isCompanyLevel = computed<boolean>(() => store.getters.isCompanyLevel);
  const isUnitLevel = computed<boolean>(() => store.getters.isUnitLevel);

  return {
    capDonVi,
    isCompanyLevel,
    isUnitLevel,
  };
};

export default useCapDonVi;
